import { checkoutService } from 'core/services/checkout/checkout.service';
import type { TSliceExtraReducer } from 'core/store';
import { authGetCustomerSelector } from 'core/store/auth/selectors';
import { createAppAsyncThunk } from 'core/store/store.utils';
import { getCustomerIdFromCheckout, getInitialCheckoutParams, getInitialCheckoutValues } from '../checkout-state.utils';
import { checkoutInitialState, resetCheckoutLoading, SLICE_NAMESPACE } from '../constants';
import type { ICheckoutState } from '../types';

export const refreshCheckoutDetailAction = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/refreshCheckout`,
  async (_, { getState }) => {
    const state = getState();
    const { checkout } = state;
    const customer = authGetCustomerSelector(state);
    const customerId = getCustomerIdFromCheckout(checkout);
    const { source } = customer;

    const params = getInitialCheckoutParams({
      checkoutDetail: checkout.detail,
      checkoutPaymentMethod: checkout.paymentMethod,
      checkoutAddress: checkout.address,
      customerSource: source,
    });

    const detail = await checkoutService.getCheckoutDetail(customerId, source, params);
    const initialValues = getInitialCheckoutValues(detail, customer);

    return {
      detail,
      initialValues,
    };
  },
);

export const refreshCheckoutReducer: TSliceExtraReducer<ICheckoutState> = builder => {
  builder
    .addCase(refreshCheckoutDetailAction.fulfilled, (state, { payload }) => {
      const { detail, initialValues } = payload;
      state.loading = resetCheckoutLoading;
      state.detail = detail;
      state.shipping.deliveryDates = initialValues.deliveryDates;
      state.paymentMethod = checkoutInitialState.paymentMethod;
    })
    .addCase(refreshCheckoutDetailAction.rejected, state => {
      state.loading = resetCheckoutLoading;
    });

  return builder;
};
